import axios from 'axios';
import ApiConstants from './apiConstants';

const registerApiInstance = axios.create({
  baseURL: process.env.REACT_APP_REGISTER_URL,
  timeout: 5000,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    'Content-Type': 'application/json',
    Accept: 'application/json',
    cache: 'no-cache',
    mode: 'cors',
    redirect: 'follow',
    'x-user-agent': 'test',
    referrer: 'no-referrer',
  },
});

registerApiInstance.interceptors.request.use(
  async (config) => {
   
    if (!config.headers['Authorization']) {
      delete config.headers['Authorization'];
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default registerApiInstance;
